import { IonFab, IonFabButton } from '@ionic/react';
import React, { useState } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { HeaderPopover } from '../components/HeaderPopover';
import { GearIcon, CalendarPlusIcon, InnerhivePlusIcon } from '../theme/Icons';
import { MenuItem } from '../components/MenuItem';
import { useSubscription } from '@meraki-internal/state';
import { RevenueCatModel } from '../innerhive-plus/revenue-cat/RevenueCatModel';
import { InnerhivePlusDialogViewModel } from '../innerhive-plus/InnerhivePlusDialogViewModel';
import { ConnectCalendarViewModel } from './ConnectCalendarViewModel';

export const AppointmentsConfigPopover: React.FC = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);

    const careMapState = useInstance(CareMapState);
    const dialogVM = useInstance(InnerhivePlusDialogViewModel);
    const connectCalDialogVM = useInstance(ConnectCalendarViewModel);

    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    const showConnectCalendar = careMapState.getActiveCaremap()?.essentialMapComplete;
    if (!showConnectCalendar){
        return null;
    }

    const toggleMenu = () => {
        setMenuOpen(oldState => {
            return !oldState;
        });
    };

    const hasInnerhivePlus = revenueCat.hasInnerhivePlus();

    const connectCalendar = async () => {
        setMenuOpen(false);

        if (hasInnerhivePlus) {
            connectCalDialogVM.open('appointments settings');
        } else {
            const nowHasInnerhivePlus = await dialogVM.requirePurchase({ triggerSource: 'connect calendar' });
            if (nowHasInnerhivePlus) {
                connectCalDialogVM.open('appointments settings');
            }
            // do nothing, user canceled paywall
        }
    };

    return (
        <>
            <IonFab
                onClick={toggleMenu}
                activated={isMenuOpen}
                id="appts-config-button"
                style={{position: 'fixed', bottom: 20, right: 20, pointerEvents: 'all', zIndex: 5}}
            >
                <IonFabButton color="light" size="small">
                    <GearIcon color="primary" />
                </IonFabButton>
            </IonFab>

            <HeaderPopover
                isBottomFAB
                maxWidth="smaller"
                trigger="appts-config-button"
                isOpen={isMenuOpen}
                onDidDismiss={() => setMenuOpen(false)}
                lowerContent={
                    <MenuItem
                        data-id="connect-calendar"
                        onClick={connectCalendar}
                        label={
                            <>
                                Connect Your Calendar
                                {!hasInnerhivePlus && <span style={{marginLeft: 8}}><InnerhivePlusIcon color="secondary" /></span>}
                            </>
                        }
                        Icon={CalendarPlusIcon}
                    />
                }
            />
        </>
    );
};
